import { supplierOrder } from './supplierOrder';

const supplierOrders = {
  items: {
    ...supplierOrder,
  },
};

export { supplierOrders };